import type { FC, PropsWithChildren, ReactNode } from 'react';

import cn from '@/lib/packages/cn';

type TPillProps = PropsWithChildren<{
  className?: string;
  leftIcon?: ReactNode;
  size?: 'sm' | 'md';
}>;

const sizeClasses: Record<NonNullable<TPillProps['size']>, string> = {
  sm: 'px-2 py-1 text-[12px] leading-tight',
  md: 'px-2.5 py-1.5 text-[13px] leading-tight',
};

const Pill: FC<TPillProps> = ({ children, className, leftIcon, size = 'sm' }) => {
  return (
    <span
      className={cn(
        'inline-flex flex-none items-center gap-1 rounded-full bg-gray-100 font-medium text-primary-foreground ring-1 ring-gray-900/10 ring-inset dark:bg-white/10 dark:ring-white/10',
        sizeClasses[size],
        className,
      )}
    >
      {leftIcon}
      {children}
    </span>
  );
};

export default Pill;
